const COUNTRIES_WITH_FREE_MESSAGES = Object.freeze(['CH', 'DE', 'AT']);

const countryHasFreeMessages = function(country) {
  return COUNTRIES_WITH_FREE_MESSAGES.includes(String(country || '').trim().toUpperCase());
};

export { COUNTRIES_WITH_FREE_MESSAGES, countryHasFreeMessages };
